import { gql } from "@apollo/client";export default gql`query conceptAggregate($where: concept_bool_exp) {
    conceptAggregate: concept_aggregate(where: $where) {
        aggregate {
            count
        }
    }
}
`;
